export class ServiceError extends Error {
  constructor(readonly error: unknown, readonly requestId: string) {
    super(`${error}`);
  }
}

export class ServiceHttpError extends ServiceError {
  constructor(
    readonly status: number,
    readonly responseText: string,
    requestId: string,
    readonly detail?: string,
  ) {
    super(`${status}: ${responseText}`, requestId);
  }
}

export function generateRequestId() {
  const randomText = Math.random().toString(36).substring(2, 10).toUpperCase();
  // c stands for "client" generated
  return 'c' + randomText;
}
